import Box from '@mui/material/Box';
import Button from '../../../componentsv2/Button';
import { useTranslation } from '../../../hooks/i18n';
import { ArrowRightIcon } from '../../../components/Icons';

interface StepButtonsProps {
  onNext: () => void;
  onBack?: () => void;
  isNextLoading?: boolean;
  isNextDisabled?: boolean;
  nextLabel?: string;
}

const StepButtons = ({ onNext, onBack, isNextLoading, isNextDisabled, nextLabel }: StepButtonsProps) => {
  const { t } = useTranslation(['activation']);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: '16px',
        marginTop: 'auto',
        paddingTop: '48px',
        paddingBottom: '24px',
      }}
    >
      {onBack && (
        <Button type="outline" color="tertiary" onClick={onBack} isFullHeight={false}>
          {t('activation:buttons.back')}
        </Button>
      )}
      <Button
        color="primary"
        onClick={onNext}
        disabled={isNextDisabled}
        isLoading={isNextLoading}
        endIcon={<ArrowRightIcon />}
        isFullHeight={false}
      >
        {nextLabel || t('activation:buttons.nextStep')}
      </Button>
    </Box>
  );
};

export default StepButtons;
